import styles from './Lightbulb.module.sass'
import Image from "next/image";
import cn from "classnames";
import {forwardRef} from "react";

const Lightbulb = forwardRef(({ className, ...props}, forwardedRef) => {
	return (
			<div className={cn(styles.lightbulb, className, 'Lightbulb__lightbulb')} {...props}>
				<div className={styles.bubble__wrapper}>
					<Image className={cn(styles.bubble, 'Lightbulb__bubble')}  ref={forwardedRef} src={'/images/Game/Lightbulb/light_bubble_gif.png'} alt={"Bubble"} width={130} height={128}/>
				</div>
				<Image className={cn(styles.light_bubble, 'Lightbulb__light_bubble')} src={'/images/Game/Timeline/light_bubble.gif'} alt={"Light Bubble"} width={29} height={20}/>
			</div>
	);
});

export default Lightbulb;
